import { render, staticRenderFns } from "./CallToAction.vue?vue&type=template&id=fa8af482&"
import script from "./CallToAction.vue?vue&type=script&lang=ts&"
export * from "./CallToAction.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Buildserver\\Agent01\\_work\\1030\\s\\JCD.Retail.Webshop\\App\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fa8af482')) {
      api.createRecord('fa8af482', component.options)
    } else {
      api.reload('fa8af482', component.options)
    }
    module.hot.accept("./CallToAction.vue?vue&type=template&id=fa8af482&", function () {
      api.rerender('fa8af482', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CallToAction.vue"
export default component.exports